export { default } from './generate-transcript-modal'
